import { X } from "lucide-react";
import { useRef, useState } from "react";

const services = [
  {
    title: "Tôlerie et peinture",
    desc: "Redressage, pièces d'origine et peinture en cabine. La teinte est mesurée au spectrophotomètre. Compter 3 à 10 jours.",
    detail: (
      <>
        <p className="mb-4">
          Qu'il s'agisse d'un simple accrochage sur parking, d'un choc frontal ou latéral, ou d'un sinistre plus important, notre atelier de tôlerie dispose de l'équipement professionnel le plus avancé pour redonner à votre véhicule son état d'origine.
        </p>
        <p className="font-semibold text-foreground mb-3">Notre processus en 5 étapes :</p>
        <div className="space-y-4">
          {[
            ["1. Expertise & Devis", "Inspection visuelle complète et minutieuse de tous les éléments endommagés. Nous photographions chaque dommage pour constituer un dossier complet destiné à votre assurance. Établissement d'un devis détaillé et transparent, poste par poste."],
            ["2. Tôlerie", "Redressage des éléments déformés avec vérins hydrauliques professionnels et marbre de contrôle pour garantir un alignement parfait. Remplacement des pièces trop endommagées par des pièces constructeur neuves. Contrôle dimensionnel au laser."],
            ["3. Préparation Peinture", "Ponçage minutieux des surfaces avec grain progressif (320 à 800). Application du mastic de finition. Application de l'apprêt antirouille haute performance. Masquage soigneux de toutes les zones à protéger."],
            ["4. Peinture en Cabine", "Correspondance colorimétrique parfaite grâce à notre spectrophotomètre. Peinture en cabine pressurisée avec filtration HEPA. Application en 3 couches : base, effet métallisé ou nacré, puis vernis de finition haute brillance."],
            ["5. Polissage & Finitions", "Polissage professionnel pour éliminer l'effet \"peau d'orange\". Lustrage final pour obtenir une brillance miroir. Remontage soigneux de tous les éléments démontés. Nettoyage complet avant restitution."],
          ].map(([title, text]) => (
            <div key={title}>
              <p className="font-semibold text-foreground text-xs uppercase tracking-wider mb-1">{title}</p>
              <p>{text}</p>
            </div>
          ))}
        </div>
        <p className="mt-4 font-semibold text-foreground">Durée : 3 à 10 jours selon l'étendue des dégâts</p>
      </>
    ),
  },
  {
    title: "Débosselage sans peinture (PDR)",
    desc: "Pour la grêle et les coups de portière. La peinture d'origine reste intacte. 1 à 3 heures.",
    detail: (
      <>
        <p className="mb-4">Le Paintless Dent Repair (PDR) est une méthode révolutionnaire qui permet de supprimer les bosses et impacts sans toucher à la peinture d'origine de votre véhicule.</p>
        <p className="font-semibold text-foreground mb-2">Idéal pour :</p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>Impacts de grêle (multiples petits impacts)</li>
          <li>Coups de portière sur parking</li>
          <li>Petites bosses rondes de moins de 5 cm de diamètre</li>
          <li>Déformations légères sans dommage à la peinture</li>
        </ul>
        <p className="font-semibold text-foreground mb-3">Les 5 avantages du PDR :</p>
        <div className="space-y-3 mb-4">
          <div><span className="font-semibold text-foreground">Économique</span> : 50 à 70% moins cher qu'une réparation traditionnelle avec peinture.</div>
          <div><span className="font-semibold text-foreground">Rapide</span> : Intervention en 1 à 3 heures seulement selon le nombre d'impacts.</div>
          <div><span className="font-semibold text-foreground">Préserve la peinture</span> : Aucun risque de différence de teinte. La peinture d'origine reste intacte.</div>
          <div><span className="font-semibold text-foreground">Valeur maintenue</span> : Aucune trace de réparation visible, préserve la valeur de revente.</div>
          <div><span className="font-semibold text-foreground">Écologique</span> : Aucun produit chimique utilisé, aucune peinture, aucun déchet.</div>
        </div>
        <p className="font-semibold text-foreground mb-2">Technique utilisée :</p>
        <p className="mb-4">Notre spécialiste accède à la face interne du panneau de carrosserie et utilise des tiges métalliques spéciales pour exercer une pression progressive et contrôlée depuis l'arrière de la bosse.</p>
        <p className="font-semibold text-foreground">Durée : 1 à 3 heures selon le nombre d'impacts</p>
      </>
    ),
  },
  {
    title: "Jantes et detailing",
    desc: "Jantes alliage frottées remises en état en 1 à 2 jours. Polish et protection céramique, de 4 heures à 2 jours.",
    detail: (
      <>
        <h4 className="font-bold text-foreground text-base mb-3">Réparation & Peinture de Jantes</h4>
        <p className="mb-4">Les jantes en alliage léger sont particulièrement sensibles aux chocs contre les bordures de trottoir. Une jante abîmée nuit à l'esthétique et peut affecter l'équilibrage des roues.</p>
        <p className="font-semibold text-foreground mb-2">Types de dommages réparables :</p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>Rayures profondes (contact avec trottoir)</li>
          <li>Éraflures de surface</li>
          <li>Petites déformations du rebord</li>
          <li>Oxydation ou corrosion localisée</li>
          <li>Peinture écaillée ou ternie</li>
        </ul>
        <p className="font-semibold text-foreground mb-6">Durée : 1 à 2 jours pour 4 jantes</p>
        <hr className="border-border mb-6" />
        <h4 className="font-bold text-foreground text-base mb-3">Polish & Detailing Premium</h4>
        <p className="mb-4">Avec le temps, les agressions extérieures ternissent progressivement la peinture. Notre service de polish professionnel restaure la brillance d'origine et protège durablement votre carrosserie.</p>
        <div className="space-y-5">
          {[
            { name: "Formule Polish Classique", items: ["Lavage haute pression avec décontamination complète", "Polish en 1 étape pour correction des micro-rayures", "Application d'une cire de protection haute qualité"], time: "4 heures" },
            { name: "Formule Detailing Premium", items: ["Polish en 2 étapes : correction + finition miroir", "Application d'un coating céramique professionnel (12 mois)", "Nettoyage intérieur complet"], time: "1 journée complète" },
            { name: "Formule Show Car", items: ["Polish en 3 étapes + coating céramique multicouches (3 ans)", "Nettoyage moteur + désinfection habitacle à l'ozone"], time: "2 jours complets" },
          ].map((f) => (
            <div key={f.name}>
              <p className="font-semibold text-foreground mb-1">{f.name}</p>
              <ul className="list-disc list-inside space-y-1">
                {f.items.map((item) => <li key={item}>{item}</li>)}
              </ul>
              <p className="mt-1 text-foreground font-medium">Durée : {f.time}</p>
            </div>
          ))}
        </div>
      </>
    ),
  },
];

const ServicesSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const ref = useRef<HTMLDivElement>(null);

  const handleOpen = (i: number) => {
    setOpenIndex(i);
    setTimeout(() => {
      ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  };

  const handleClose = () => setOpenIndex(null);
  const expanded = openIndex !== null ? services[openIndex] : null;

  return (
    <section id="services" className="py-24 relative">

      <div className="container mx-auto px-4">
        <div className="mb-12 max-w-2xl">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-4">Nos services</h2>
          <p className="text-muted-foreground">
            Toutes marques, pièces d'origine en priorité. Le devis est gratuit.
          </p>
        </div>

        <div ref={ref} className="relative">
          <div
            className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-500 ${
              openIndex !== null ? "opacity-0 scale-95 pointer-events-none absolute inset-0" : "opacity-100 scale-100"
            }`}
          >
            {services.map((s, i) => (
              <div
                key={s.title}
                className="glass-card rounded-lg p-6"
              >
                <h3 className="font-semibold text-lg mb-3 tracking-tight">{s.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
                <button
                  onClick={() => handleOpen(i)}
                  className="mt-4 flex items-center gap-1.5 text-primary text-sm font-medium hover:underline transition-all cursor-pointer"
                >
                  En savoir plus
                </button>
              </div>
            ))}
          </div>

          {expanded && (
            <div className="animate-fade-in-up" style={{ animationDuration: "0.4s" }}>
              <div className="glass-card rounded-lg overflow-hidden">
                <div className="flex items-start justify-between p-6 pb-4 border-b border-border">
                  <div className="flex items-center gap-4">
                    <div>
                      <h3 className="font-bold text-xl tracking-tight">{expanded.title}</h3>
                      <p className="text-sm text-muted-foreground mt-1">{expanded.desc}</p>
                    </div>
                  </div>
                  <button onClick={handleClose} className="p-2 rounded-lg hover:bg-muted transition-colors shrink-0 cursor-pointer" aria-label="Fermer">
                    <X className="w-5 h-5 text-muted-foreground" />
                  </button>
                </div>
                <div className="p-6 text-sm text-muted-foreground leading-relaxed max-h-[60vh] overflow-y-auto">
                  {expanded.detail}
                </div>
                <div className="p-6 pt-2 border-t border-border">
                  <a href="#contact" className="inline-flex items-center justify-center rounded-lg bg-primary text-primary-foreground px-6 py-3 text-sm font-medium hover:bg-primary/90 active:scale-95 transition-all">
                    Demander un devis
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
